import styled from "styled-components"





export const Wrapper = styled.div`

.Expense-label {
    color: #566787;
    padding-bottom: 2px;
  }
  .Expense-Input {
    border-radius: 2px;
    box-shadow: none;
    border-color: #dddddd;
    font-size: 15px;
  }
`;
